import React from 'react';
import { Tag } from './Tag';
import { Icon } from '../Icon/Icon';

export function TagExample(): JSX.Element {
  return (
    <div className="styleguide__tags">
      <Tag
        text="This is a Tag with an accessory"
        backgroundColor="var(--color-tint)"
        accessory={<Icon name="remove" />}
      />
      <Tag text="This is also a Tag" backgroundColor="var(--color-background-menu)" />
      <Tag text="This is a Tag with a long and truncated text" backgroundColor="var(--color-ticket-reserved)" />
    </div>
  );
}
